import { render, staticRenderFns } from "./AddSystemPage.vue?vue&type=template&id=1f25b21c&"
import script from "./AddSystemPage.vue?vue&type=script&lang=js&"
export * from "./AddSystemPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports